import { render, staticRenderFns } from "./printOfSmall.vue?vue&type=template&id=91f23110&scoped=true&lang=html&"
import script from "./printOfSmall.vue?vue&type=script&lang=js&"
export * from "./printOfSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f23110",
  null
  
)

export default component.exports